// extracted by mini-css-extract-plugin
module.exports = {"infoItems":"productInfo_infoItems__Rn_4X","infoItemLabel":"productInfo_infoItemLabel__TkETk","infoItemValue":"productInfo_infoItemValue__osekx","arrow":"productInfo_arrow__5ixKV"};